import { createReducer, on } from '@ngrx/store';
import { AuthState } from '../../shared/models';
import * as AuthActions from './auth.actions';

const initialState: AuthState = {
  user: null,
  accessToken: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

export const authReducer = createReducer(
  initialState,
  // Session hydration
  on(AuthActions.hydrateSession, (state, { user, accessToken }) => ({
    ...state,
    user,
    accessToken,
    isAuthenticated: true,
    isLoading: false,
    error: null,
  })),

  // Login
  on(AuthActions.login, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(AuthActions.loginSuccess, (state, { user, accessToken }) => ({
    ...state,
    user,
    accessToken,
    isAuthenticated: true,
    isLoading: false,
    error: null,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Register
  on(AuthActions.register, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(AuthActions.registerSuccess, (state, { user, accessToken }) => ({
    ...state,
    user,
    accessToken,
    isAuthenticated: true,
    isLoading: false,
    error: null,
  })),
  on(AuthActions.registerFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Register with Code
  on(AuthActions.registerWithCode, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(AuthActions.registerWithCodeSuccess, (state, { user, accessToken }) => ({
    ...state,
    user,
    accessToken,
    isAuthenticated: true,
    isLoading: false,
    error: null,
  })),
  on(AuthActions.registerWithCodeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Register Create Tenant
  on(AuthActions.registerCreateTenant, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(AuthActions.registerCreateTenantSuccess, (state, { user, accessToken, isTemporaryAdmin }) => ({
    ...state,
    user,
    accessToken,
    isAuthenticated: true,
    isTemporaryAdmin,
    isLoading: false,
    error: null,
  })),
  on(AuthActions.registerCreateTenantFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Logout
  on(AuthActions.logout, () => initialState),

  // Get Profile
  on(AuthActions.getProfile, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(AuthActions.getProfileSuccess, (state, { user }) => ({
    ...state,
    user,
    isLoading: false,
  })),
  on(AuthActions.getProfileFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Enable MFA
  on(AuthActions.enableMfa, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(AuthActions.enableMfaSuccess, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(AuthActions.enableMfaFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Clear Error
  on(AuthActions.clearError, (state) => ({
    ...state,
    error: null,
  }))
);
